export default async function getCountryFromCoords(lat, lon) {
  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
    );
    const data = await res.json();
    return {country:data.address.country, country_code:data.address.country_code};
  } catch (err) {
    console.error("Error fetching country:", err);
    return null;
  }
}

// example coordinates for Kyoto, Japan
// longitute `135.7681441`
// latitute `35.0115754`